import React from 'react';
import Popup from "reactjs-popup";
import { CsvButton,downloadCSV } from '../../../service/CsvButton';
import { ReactTableServerSide } from '../../ReactTableServerSide';
import auth from '../../../service/Auth';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {GPAP_Button_light, GPAP_Button_Orange} from "../../../../gpap-lib/Button_Collection";
import {experiments_no_files} from '../../../service/apis';
import {matchSorter} from "match-sorter";
import settings from '../../../DataManagementConfig';

const config = window.config;

const exp_search_delayed = ['ExperimentID', 'LocalExperimentID', 'Participant_ID'];

export class ExperimentsNoFiles extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            headers: [
                { label: 'Experiment ID', key: 'ExperimentID', tooltip: "Unique Experiment Identifier."},
                { label: 'Local Experiment ID', key: 'LocalExperimentID'},
                { label: 'Participant ID', key: 'Participant_ID'},
                { label: 'Owner', key: 'Owner'},
                { label: 'Projects', key: 'project'},
                { label: 'Protocol/Kit', key: 'kit'},
                { label: 'Tissue', key: 'tissue'},
                { label: 'Library Strategy', key: 'library_strategy'},
                { label: 'Library Construction Protocol', key: 'library_contruction_protocol'},
                { label: 'Postembargo', key: 'POSTEMBARGO'},
                { label: 'Processed', key: 'processed', tooltip: "Variant calling already generated."},
                { label: 'In Platform', key: 'in_platform', tooltip: "Experiment fully processed and uploaded to GPAP Platform for analysis."},
                { label: 'LoadDate', key: 'LOADDATE'}
            ],
            experimets: [],
            pagination: {
                loadData: true,
                page: 0,
                pages: 0,
                pageSize: settings.basicPageSize,
                totalItems: 0,
                fields: [],
                filtered: [],
                sorted: []
            },
            csvData:[],
            csvFileName: "",
            popupErrors: "",
            filtered: []
        };
    }

    componentDidMount() {
        /* Check token expired */
        if (auth.tokenExpired())
        {
            this.setState({ popupErrors: "Logging session timeout. Please log again" });
        }
        else if (!auth.isUserAdmin()) {
            this.setState({ popupErrors: "User does not have admin permissions." });
        }
    }

    getDataColumnTable() {
       //Translates API Data result to data and columns for react-table
       let columns = []
       //Add Headers Titles
       //Boolean Values
       let booleanKeyHeaders = ['POSTEMBARGO','processed','in_platform']
       for (let header of this.state.headers) {
             let column = {};
             if ("tooltip" in header){
                 column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
             }
             else{
                 column["Header"] = header.label;
             }
             column["accessor"] = header.key;
             column["minWidth"] = 220;
             //Boolean Filters
             if (booleanKeyHeaders.includes(header.key)){
                column["Filter"] = ({ filter, onChange }) =>
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : "all"}
                    >
                        <option value="">all</option>
                        <option value="true">true</option>
                        <option value="false">false</option>
                    </select>;
                column["filterMethod"] = (filter, rows) => matchSorter(rows, filter.value, { keys: ["index"] });
                column["filterAll"] = true;
             }
             columns.push(column);
       }
       //Build data to render on react-table
       let data = [];

       for (let n_experiment in this.state.experiments){
           let experiment = this.state.experiments[n_experiment];
           let row = {};
           //1. Loop Headers
           for (let column of columns){
               if (typeof experiment[column.accessor] === "boolean"){
                   row[column.accessor] = experiment[column.accessor].toString();
               }
               else {
                   row[column.accessor] = experiment[column.accessor];
               }
           }
           //2. Add row to data
           data.push(row);
       }
       //Update columns and data
       return [columns, data];
    }

    closeModal = () => {
        this.setState({ popupErrors: "" });
    };

    /*Method to call API Endpoint to get React Table Data*/
    loadTableData = (state,instance) => {
        let fields = [];
        // Update Laod Process
        this.setState({ pagination : {loadData:true}});
        /*Get fields to be requiered*/
        for (let header of this.state.headers) {
            fields.push(header.key);
        }
        /*Call API Endpoint*/
        let data_query = {
            "page" : (state.page + 1),
            "pageSize" : state.pageSize,
            "fields" : fields,
        }
        /*Check filtered Criteria*/
        if (state.filtered) {
            data_query["filtered"] = state.filtered.map( item => ( { id:item.id, value:[item.value]} ) );
        }
        /*Check sorted Criteria*/
        if (state.sorted) {
            data_query["sorted"] = state.sorted;
        }
        /* Call POST Data*/
        experiments_no_files(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            this.setState({"experiments" : data["items"],
                            pagination : {
                              page : data["_meta"]["page"],
                              pages : data["_meta"]["total_pages"],
                              pageSize : data["_meta"]["page_size"],
                              totalItems : data["_meta"]["total_items"],
                              fields :fields,
                              filtered : state.filtered,
                              sorted : state.sorted,
                              loadData : false
                            }
                          }
                        );
        })
    }

    getCsvData = async (headers) => {
        /*Trigger Load Process*/
        let pagination = this.state.pagination;
        pagination.loadData = true;
        this.setState({ pagination : pagination });
        /*Get All Data to be printed to CSV Files*/
        let data_query = {
            "page" : 1,
            "pageSize" : 2000,
            "fields" : this.state.pagination.fields,
            "filtered" : this.state.pagination.filtered.map( item => ( { id:item.id, value:[item.value]} ) ),
            "sorted": this.state.pagination.sorted
        };
        let getData = true;
        let allItems = [];
        /*Get All Data*/
        while (getData){
              /*Call POST Data*/
              await experiments_no_files(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
              .then((response) => {
                  return response.json()
              })
              .then((data) => {
                  allItems.push(...data["items"]);
                  if (data_query.page < data["_meta"]["total_pages"]){
                        getData = true;
                        data_query.page = data_query.page + 1;
                  }
                  else getData = false;
              })
        }
        //Build data for CSV
        let data = [];
        for (let item of allItems){
            let row = {};
            //1. Loop Headers
            for (let header of this.state.headers){
                if (typeof item[header.key] === "boolean") row[header.key] = item[header.key].toString();
                else row[header.key] = item[header.key];
            }
            //2. Add row to data
            data.push(row);
        }

        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(data,this.state.headers,`${today}_experiments_no_files.csv`);
        pagination.loadData = false;
        this.setState({ pagination : pagination});
    }

    render(){
        /*Show popup in case an error with the loggin occurs*/
        if (this.state.popupErrors) {
            return (
                <Popup
                    open={true}
                >
                <div>
                    <div className="page-header"> <h1> Logging error. </h1> </div>
                    <div className="alert alert-warning">{this.state.popupErrors} </div>
                    <GPAP_Button_Orange href = "#/admin"  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_Orange>
                </div>
                </Popup>);
        }
        else {
            const columnsDataTable = this.getDataColumnTable();

            return (
                <div className={"mainContent"}>
                    <Typography variant={"h5"} align={"center"}> Experiments without files declared </Typography>

                    <GPAP_Button_light href = "#/admin"  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_light>
                    <CsvButton getCsvData={this.getCsvData} />

                    <ReactTableServerSide
                        headers={this.state.headers}
                        columns={columnsDataTable[0]}
                        data={columnsDataTable[1]}
                        pagination={ this.state.pagination }
                        onRowClick={this.onRowClick}
                        loadTableData={this.loadTableData}
                        loading={this.state.pagination.loadData}
                        fieldsDelay={exp_search_delayed}
                    />
                </div>
            );
        }
    }
}






